import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref } from "vue";
const _hoisted_1 = { class: "demand-article__content" };
const _hoisted_2 = { class: "demand-article__attributes" };
const _hoisted_3 = { class: "demand-article__title" };
const _hoisted_4 = { class: "demand-article__info" };
const _hoisted_5 = { class: "badge demand-article__sku" };
const _hoisted_6 = { class: "demand-article__prices" };
const _hoisted_7 = { class: "demand-article__price demand-article__price--ordering-unit" };
const _hoisted_8 = { class: "demand-article__price" };
const _hoisted_9 = ["src", "alt"];
import { computed } from 'vue';
import Price from "@astina/paloma-shop-common-ui/src/components/Price.vue";
import ProductAttributeValue from "@astina/paloma-shop-common-ui/src/components/ProductAttributeValue.vue";
import config from '../services/PortalConfig';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DemandCalendarArticle',
    props: {
        variant: {}
    },
    emits: ['hover'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const attributes = computed(() => {
            return props.variant.attributes.map(attr => {
                const values = [];
                for (let i = 0; i < attr.values.length; i++) {
                    const value = attr.values[i];
                    const valueCode = attr.valueCodes[i];
                    values.push({
                        attribute: attr,
                        value: value,
                        valueCode: valueCode
                    });
                }
                return values;
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                onMouseover: _cache[0] || (_cache[0] = ($event) => (emit('hover', __props.variant))),
                class: "demand-article"
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attributes.value, (attribute, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: _normalizeClass(["demand-article__attribute", 'demand-article__attribute--type-' + attribute[0].attribute.type])
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attribute, (value, index2) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        class: "demand-article__attribute-value",
                                        key: index2
                                    }, [
                                        _createVNode(ProductAttributeValue, {
                                            attribute: value.attribute,
                                            value: value.value,
                                            "value-code": value.valueCode
                                        }, null, 8, ["attribute", "value", "value-code"])
                                    ]));
                                }), 128))
                            ], 2));
                        }), 128))
                    ]),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.variant.title), 1),
                    _cache[4] || (_cache[4] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(__props.variant.sku), 1),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                (__props.variant.price)
                                    ? (_openBlock(), _createBlock(Price, {
                                        key: 0,
                                        currency: __props.variant.price.currency,
                                        amount: __props.variant.price.unitPrice,
                                        unit: __props.variant.price.unit
                                    }, null, 8, ["currency", "amount", "unit"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_8, [
                                (__props.variant.baseUnitPrice && __props.variant.baseUnitPrice.unitCode !== __props.variant.price?.unitCode)
                                    ? (_openBlock(), _createBlock(Price, {
                                        key: 0,
                                        currency: __props.variant.baseUnitPrice.currency,
                                        amount: __props.variant.baseUnitPrice.unitPrice,
                                        unit: __props.variant.baseUnitPrice.unit
                                    }, null, 8, ["currency", "amount", "unit"]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ])
                ]),
                _cache[5] || (_cache[5] = _createTextVNode()),
                (_unref(config).demand.showImages)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["demand-article__image", { 'is-empty': !__props.variant.image }])
                    }, [
                        (__props.variant.image)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: __props.variant.image,
                                alt: __props.variant.title
                            }, null, 8, _hoisted_9))
                            : _createCommentVNode("", true)
                    ], 2))
                    : _createCommentVNode("", true)
            ], 32));
        };
    }
});
